import { TDayItem } from '@/domain/Availability.domain';
import { TAvailabilityDayFullResponse } from '@/domain/FullCalendar.domain';
import { TPricesForSchedules } from '@/domain/Prices.domain';

export const mapFullDayToDayItems = (
    fullDay: TAvailabilityDayFullResponse,
    needTicketsNames: boolean,
    prices?: TPricesForSchedules
): TDayItem => {
    const schedulesData = Object.values(fullDay.schedules).map(
        ({ time, id, min_tickets, tickets_avail, min_price, tickets }) => ({
            time,
            schedule_id: id,
            min_tickets: +min_tickets,
            description: '',
            is_avail: true,
            tickets: {
                avail: tickets_avail,
                total: 0,
            },
            call_to_booking: false,
            min_price,
            price: +min_price,
            durations: Object.values(tickets).reduce((res, { duration }) => {
                if (!res.includes(duration)) {
                    if (!res) {
                        res = duration;
                    } else {
                        res = res + ',' + duration;
                    }
                }

                return res;
            }, ''),
        })
    );

    const schedules = {
        trip_id: +fullDay.id,
        trip_name: fullDay.name,
        need_ticket_names: needTicketsNames,
        schedules: schedulesData,
        has_overnights: true,
    };

    if (!prices) {
        return schedules;
    }

    const pricesData = prices.schedules.reduce(
        (res, item) => {
            res[item.schedule_id] = item.price_from;

            return res;
        },
        {} as { [key: number]: number }
    );

    schedules.schedules.forEach((schedule) => {
        schedule.price = pricesData[schedule.schedule_id] || prices.default;
    });

    return schedules;
};

export const getOvernightsDurations = (fullDay: TAvailabilityDayFullResponse) => {
    return Object.values(fullDay.schedules).reduce(
        (res, schedule) => {
            Object.values(schedule.tickets).forEach((ticket) => {
                if (!res[ticket.duration]) {
                    res[ticket.duration] = ticket.name;
                }
            });
            return res;
        },
        {} as { [key: string]: string }
    );
};
